export interface FalconApiConfigInterface {
    falconApiUrl: string
}

export const falconApiConfig: FalconApiConfigInterface = {
    falconApiUrl: process.env.REACT_APP_FALCON_API_URL as string
}
